module.exports = __webpack_public_path__ + "static/media/vikas_spools.9fa94071.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/client_logo/vikas_spools.jpg
// module id = 22
// module chunks = 0